import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp16};
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  align-self: stretch;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.primary};
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Description = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp16};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  align-self: stretch;
  border-radius: ${props => props.theme.primitives.radius.radius1};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  background-color: ${props => props.theme.colors.disabled.surface};
`

export const EventInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
